import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import moment from "Helpers/MomentCompat";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import Button from "Components/Admin/Buttons";

import CalendarBulk from "../CalendarBulk";
import CalendarForm from "../CalendarForm";
import * as S from "./styles";

// Moderação do CRONOGRAMA (B04 — D12 da parte 2, 03/09/2026): o evento criado
// pelo proponente nasce Pendente e só chega ao patrocinador depois que o admin
// aprova. Mesmo molde da moderação da Galeria (A10).
const UpdateProjectCalendar = ({ projectId, onModerated }) => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading();

  const evaluateEvent = async (date_id, approved) => {
    setLoading(true);

    try {
      await api.post("/projects/dates/evaluate", { date_id, approved });

      setLoading(false);
      showNotification("success", "Sucesso!", "Evento avaliado com sucesso!");
      getProjectDates(projectId);
      // Avaliou: o badge da aba precisa cair na hora (05/09/2026).
      if (onModerated) onModerated();
    } catch (error) {
      setLoading(false);
      return HTTPErrorCallback(error);
    }
  };

  const [calendar, setCalendar] = useState([]);

  const [openModal, setOpenModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (projectId) {
      return getProjectDates(projectId);
    }

    // eslint-disable-next-line
  }, [projectId]);

  const getProjectDates = (project_id) => {
    api
      .post("/projects/dates", {
        project_id: project_id,
      })
      .then((response) => {
        const dates = response.data;

        setCalendar(dates);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  return (
    <S.Wrapper>
      {selectedDate ? (
        <CalendarForm
          projectId={projectId}
          getProjectDates={getProjectDates}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
      ) : null}

      {openModal ? (
        <CalendarBulk
          projectId={projectId}
          setOpenModal={setOpenModal}
          getProjectDates={getProjectDates}
        />
      ) : null}

      <Form>
        <S.Section>
          {/* A ABA virou "Cronograma" em 29/08/2026 (D28), mas o título da
              seção tinha ficado atrás. */}
          <span>Cronograma</span>
          <hr />
        </S.Section>

        <S.Buttons>
          <div />

          <S.Row>
            <Button
              type="button"
              text="Criar Datas em Massa"
              disabled={loading}
              onClick={() => setOpenModal(true)}
            />
            <Button
              type="button"
              text="Criar Data"
              disabled={loading}
              onClick={() => setSelectedDate(true)}
            />
          </S.Row>
        </S.Buttons>

        {!calendar.length ? <span>Nenhuma data cadastrada.</span> : null}

        {calendar.map((date) => (
          <S.Date key={date.id} onClick={() => setSelectedDate(date)}>
            <S.DateInfos>
              <h2>{date.name}</h2>
              {/* Evento de 1 dia (ou linha legada sem término) exibido de
                  forma simplificada — só a data (D5). */}
              {!date.finish_date ||
              moment(date.finish_date).format("YYYY-MM-DD") ===
                moment(date.date).format("YYYY-MM-DD") ? (
                <span>
                  <strong>Data:</strong>{" "}
                  {moment(date.date).format("DD/MM/YYYY")}
                </span>
              ) : (
                <span>
                  <strong>Período:</strong>{" "}
                  {moment(date.date).format("DD/MM/YYYY")} –{" "}
                  {moment(date.finish_date).format("DD/MM/YYYY")}
                </span>
              )}

              {/* NULL = linha anterior à coluna (backfill do 20260903_02),
                  lida como Aprovado. */}
              <S.Status status={date.approval_status || "Aprovado"}>
                {date.approval_status || "Aprovado"}
              </S.Status>

              {(date.approval_status || "Aprovado") === "Pendente" ? (
                <S.Evaluate
                  // O card inteiro abre o formulário de edição: sem parar a
                  // propagação, avaliar abriria o form por cima do resultado.
                  onClick={(event) => event.stopPropagation()}
                >
                  <Button
                    type="button"
                    text="Aprovar"
                    disabled={loading}
                    onClick={() => evaluateEvent(date.id, true)}
                  />
                  <Button
                    type="button"
                    variant="critical"
                    text="Reprovar"
                    disabled={loading}
                    onClick={() => evaluateEvent(date.id, false)}
                  />
                </S.Evaluate>
              ) : null}
            </S.DateInfos>
          </S.Date>
        ))}
      </Form>
    </S.Wrapper>
  );
};

export default UpdateProjectCalendar;
